import {SET_SELECTION_DATA} from '.';
import {
  SetSelectedCheckBoxPayloadParams,
  SetSelectedCheckBoxAction
} from '../mappers/SelectedCheckBoxTypesMapper';

export const setSelectedCheckBox = (
  dispatch: (action: SetSelectedCheckBoxAction) => void,
  params: SetSelectedCheckBoxPayloadParams
): void => {
  dispatch({
    type: SET_SELECTION_DATA,
    payload: params
  });
};
